var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0095FF"
    },
    points: "177.47,244.428 162.118,218.646 333.856,115.459 349.208,141.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0095FF"
    },
    points: "332.274,401.58 166.791,317.011 180.326,290.233 345.81,374.803  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00ABE9"
    },
    d: "M406,0c-49.501,0-90,40.499-90,90c0,49.499,40.499,90,90,90s90-40.501,90-90 C496,40.499,455.501,0,406,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00ABE9"
    },
    d: "M406,332c-49.501,0-90,40.499-90,90c0,49.499,40.499,90,90,90s90-40.501,90-90 C496,372.499,455.501,332,406,332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00ABE9"
    },
    d: "M106,181c-49.501,0-90,40.499-90,90c0,49.499,40.499,90,90,90s90-40.501,90-90 C196,221.499,155.501,181,106,181z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0095FF"
    },
    d: "M496,422c0,49.499-40.499,90-90,90V332C455.501,332,496,372.499,496,422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0095FF"
    },
    d: "M406,180V0c49.501,0,90,40.499,90,90C496,139.499,455.501,180,406,180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0095FF"
    },
    d: "M196,271c0,49.499-40.499,90-90,90V181C155.501,181,196,221.499,196,271z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.fb626d8faccb4ca3807e7b76a005d7a8.svg";
export { ForwardRef as ReactComponent };